import { useEffect } from 'react';
import { log } from 'log';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { useGetGamesConfiguration } from 'js/hooks/games';

export const useGamesInitialResources = () => {
    const lang = useUserSelector(prop('lang'));
    const getGamesConfiguration = useGetGamesConfiguration();

    useEffect(() => {
        (async () => {
            if (!lang) {
                return;
            }

            try {
                await getGamesConfiguration();
            } catch (e) {
                log('error', '[App] Unable to get games configuration', e);
            }
        })();
    }, [lang, getGamesConfiguration]);
};
